import LocalService from "@/core/services/local.service";
import Store from "@/core/services/store";

const AppConfiguration = {
  init() {
    Store.dispatch("setLocalConfig").then((config) => {
      LocalService.saveEncrypt("line-item-config", config.line_item);
      LocalService.saveData("app-config", {
        ...config,
        phoneMask: "+65-####-####",
        entity: config.entity,
        dateFormat: config.date_format,
        dateTimeFormat: config.date_format + " " + config.time_format,
        timeFormat: config.time_format,
        currency: { code: "SGD", symbol: "$" },
        CurrencyFormat: {
          decimal: ".",
          number: ",",
          precision: 2,
          symbol: "$",
        },
        QuantityFormat: { decimal: ".", number: ",", precision: 2 },
        NumberFormat: { decimal: ".", number: ",", precision: 2 },
        Logo: config.company_logo,
      });

      LocalService.saveData("phone_countries", config.activeCountries);
    });
  },
  get() {
    return LocalService.getData("app-config");
  },
  getLineItemConfig() {
    return LocalService.getEncrypt("line-item-config");
  },
};

export default AppConfiguration;
